import type { ReactNode } from "react";
import type { Data } from "../types/data";

interface Layout03Props {
  data: Data;
  children?: ReactNode;
}

export default function Layout03({  children }: Layout03Props) {
  return <div>Layout03 {children}</div>;
}
